<template>
  <transition name="pa-simple-fade">
    <div class="pa-connection-pod-message-box" v-if="couldShow">
      <div class="left-side">
        <div class="character-icon">
          <CharacterIcon :character="podMessage.character" />
        </div>

        <button
         class="button control-button"
         :class="plusButtonClass"
         :disabled="isPlusButtonDisabeld"
         @click.prevent="handleClickUserPlusButton(podMessage.character)"
        >
          <font-awesome-icon icon="user-plus" />
        </button>

        <button
         class="button control-button control-button-reply"
         :class="replyButtonClass"
         :disabled="isReplyButtonDisabled"
         @click.prevent="handleClickReplyButton"
        >
          <font-awesome-icon icon="reply" />
        </button>

        <button
         class="button control-button"
         :class="commentButtonClass"
         :disabled="isCommentButtonDisabled"
         @click.prevent="handleClickCommentButton"
        >
          <font-awesome-icon icon="comments" />
          <span class="reply-num">{{podMessage.reply_num | mutateFullWidth}}<span class="mini">/{{replyMaxNumber | mutateFullWidth}}</span></span>
        </button>

        <button
         v-if="isVisibleTrashButton"
         class="button control-button control-button-minify"
         :class="trashButtonClass"
         :disabled="isTrashButtonDisabled"
         @click.prevent="handleClickTrashButton"
        >
          <font-awesome-icon icon="trash" />
        </button>

        <div class="date">{{podMessage.created_at | mutateJPSimpleDate}}</div>
      </div>
      <div class="right-side">
        <div class="text-area">
          <p>{{podMessage.body}}</p>
        </div>

        <PodMessageAttachBadgeControls :podMessage="podMessage" />

        <PASimpleMessageAttachImagesView :images="podMessage.images" />

        <PodMessageReplyList :podMessage="podMessage" :isOpen="isOpenReplyMessage" />
      </div>

      <PodMessageActionConfirm
      :isOpen="isOpenTrashConfirm"
      :isLoading="isLoadingTrashConfirm"
      @handleSubmit="handleConfirmDeleteSubmitButton"
      @handleCancel="handleConfirmDeleteCancelButton"
      />
    </div>
  </transition>
</template>

<script>
import CharacterIcon                    from '@/components/Parts/CharacterIcon/CharacterIcon.vue'
import PodMessageAttachBadgeControls    from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/Parts/PodMessageAttachBadgeControls.vue'
import PASimpleMessageAttachImagesView  from '@/components/Parts/PASimpleMessageAttachImagesView/PASimpleMessageAttachImagesView.vue'
import PodMessageReplyList              from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/Parts/PodMessageReplyList.vue'
import PodMessageActionConfirm          from '@/components/Pages/Connections/ConnectionApp/components/PodMessage/Parts/PodMessageActionConfirm.vue'

import {GetMe}          from '@/graphql/queries/User.graphql'
import {GetMessageData} from '@/graphql/queries/ConnectionPod.graphql'

import {DeleteConnectionPodMessage} from '@/graphql/mutations/Pod.graphql'

export default {
  props : {
    id: {
      default: null
    },
    
    isModalView: {
      default: false
    },

    isCustomErrorHandling: {
      default:false
    }
  },

  components : {
    CharacterIcon,
    PodMessageAttachBadgeControls,
    PASimpleMessageAttachImagesView,
    PodMessageReplyList,
    PodMessageActionConfirm
  },

  data(){
    return {
      couldShow               : false,
      replyMaxNumber          : 5,

      isOpenReplyMessage      : false,

      plusButtonClass         : {
        'is-disabled' : false,
        'is-loading'  : false
      },
      isPlusButtonDisabeld    : false,

      replyButtonClass        : {
        'is-disabled' : false,
        'is-loading'  : false
      },
      isReplyButtonDisabled   : false,

      commentButtonClass      : {
        'control-button-reply-pushed' : false,
        'is-disabled'                 : false,
        'is-loading'                  : false
      },
      isCommentButtonDisabled : false,

      isVisibleTrashButton    : false,
      trashButtonClass        : {
        'is-disabled' : false,
        'is-loading'  : false
      },
      isTrashButtonDisabled   : false,

      isOpenTrashConfirm    : false,
      isLoadingTrashConfirm : false
    };
  },

  apollo : {
    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    podMessage : {
      query: GetMessageData,
      variables(){
        return {
          id : this.id
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);

        if(this.isCustomErrorHandling === true){
          this.$emit('handleLoadError', simpleErrorSet);
        }else{
          this.apolloResultValidation(simpleErrorSet);
        }
      }
    }
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    },

    urlQuery(){
      return this.$route.query;
    }
  },

  watch : {
    podMessage(data){
      if(typeof data !== 'undefined'){
        this.couldShow = true;
      }else{
        this.couldShow = false;
      }

      this.checkButtonPermission();
    },

    me(){
      this.checkButtonPermission();
    },

    isReplyButtonDisabled(value){
      this.replyButtonClass['is-disabled'] = value;
    },

    isOpenReplyMessage(value){
      this.commentButtonClass['control-button-reply-pushed'] = value;
    },

    urlQuery : {
      handler(data){
        if(this.isModalView === false) return;
        if(typeof data.open_reply === 'undefined') return;

        if(data.open_reply === 'on'){
          this.isOpenReplyMessage = true;
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods : {
    checkButtonPermission(){
      if(typeof this.me === 'undefined') return;
      if(typeof this.podMessage === 'undefined') return;
      
      // plusButton
      if(this.me.primaryCharacter.id === this.podMessage.character.id){
        this.isPlusButtonDisabeld = true;
      }else{
        this.isPlusButtonDisabeld = false;
      }

      // replyButton
      if(this.podMessage.reply_num < this.replyMaxNumber){
        this.isReplyButtonDisabled = false;
      }else{
        this.isReplyButtonDisabled = true;
      }

      // deleteButton
      if(this.podMessage.could_delete === true){
        this.isVisibleTrashButton  = true;
        this.isTrashButtonDisabled = false;
      }else{
        this.isVisibleTrashButton  = false;
        this.isTrashButtonDisabled = true;
      }
    },

    handleClickUserPlusButton(characterData){
      if(this.me.primaryCharacter.id === characterData.id) return;

      this.$store.dispatch({
        type                      : 'character/updateDetailModalIsOpen',
        value                     : true,
        characterId               : characterData.id,
        immmediateryOpenAddModal  : true,
      });
    },
    
    handleClickReplyButton(){
      this.isOpenReplyMessage = true;
      
      this.$store.dispatch({
        type        : 'createButton/updateOpenEditor',
        editorType  : 'connection',
        value       : true,
        connection  : {
          podRoomId         : this.podRoomId,
          replyPodMessageId : this.podMessage.id,
        },
      });
    },

    handleClickCommentButton(){
      this.isOpenReplyMessage = !this.isOpenReplyMessage;
    },

    handleClickTrashButton(){
      this.isOpenTrashConfirm = true;
    },

    deleteMessage(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : DeleteConnectionPodMessage,
          variables : {
            podMessageId  : this.podMessage.id
          },
          update    : (store, {data: {DeleteConnectionPodMessage: {status}}}) => {
            if(status === false){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }else{
              this.$store.dispatch({
                type  : 'connection/deletePodRoomMessage',
                value : this.podMessage.id,
              });
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    async handleConfirmDeleteSubmitButton(){
      this.isLoadingTrashConfirm = true;

      await this.UXWaiting(1000);
      await this.deleteMessage();

      this.isOpenTrashConfirm     = false;
      this.isLoadingTrashConfirm  = false;
    },

    handleConfirmDeleteCancelButton(){
      this.isOpenTrashConfirm     = false;
      this.isLoadingTrashConfirm  = false;
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-connection-pod-message-box{
  background-color: #C8A984;
  color:#604938;
  border-radius: 8px;
  display: flex;
  position: relative;

  .left-side{
    width:20%;
    .character-icon{
      width:58px;
      height:58px;
      margin:.6rem auto .4rem;
      user-select: none;
      text-align: center;

      .pa-character-icon{
        line-height: 58px;
        background-color:#C4A27A;

        @media screen and (min-width: $desktop) {
          line-height: 73px;
        }
      }

      @media screen and (min-width: $desktop) {
        width:75px;
        height:75px;
      }
    }

    .control-button{
      display: block;
      width:90%;
      margin:.2rem auto 0;
      border:0;
      height: auto;
      border-radius: 4px;
      background-color: #B99264;
      color: #7C5E49;
      text-align: center;
      font-weight: bold;
      font-size: 1rem;
      line-height: 1rem;
      padding:.1rem 0 .1rem;
      user-select:none;

      &-minify{
        margin-top:.3rem;
        margin-bottom:.2rem;
        font-size:.73rem;
      }

      &-reply{
        &-pushed{
          background-color:#B59775;
          transform: translate3d(0, 1px, 0);
        }
      }

      &.is-disabled{
        background-color: #BFA383;
        color: #B39B8B;
      }

      .reply-num{
        font-size:.7rem;
        margin-left: .15rem;

        .mini{
          font-size:.6rem;
        }
      }

      svg{
        margin-top:.1rem;
      }

      &:focus {
        outline: none;
        box-shadow:none;
      }
    }

    .date{
      font-size: .5rem;
      color:#AE8F69;
      text-align: center;
      padding:.2rem .1rem;
      font-size:.7rem;
    }
  }
  .right-side{
    width:80%;
    background-color: #C6A783;
    border-radius:0 8px 8px 0;

    .text-area{
      font-size:.9rem;
      letter-spacing: .3px;
      padding:.4rem .3rem;
      word-wrap: break-word;
    }
  }
}
</style>